export type IdentificationButtonLocationEnum = 0 | 1;

interface IIdentificationButtonLocationEnum {   
    Top: IdentificationButtonLocationEnum;
    Bottom: IdentificationButtonLocationEnum;
    format(value: number): string | undefined;
    displayTypesArray(): any[];
    getType(key: string): IdentificationButtonLocationEnum;
}

const dataSource = () => [
    { key: 0, text: 'Viršuje' },
    { key: 1, text: 'Apačioje' }
];

export const identificationButtonLocationEnum: IIdentificationButtonLocationEnum = {
    Top: 0,
    Bottom: 1,
    format(value: number) {
        const item = dataSource().find(x => x.key === value);
        return item && item.text;
    },
    displayTypesArray() {
        let types: any[] = [];
        dataSource().map(x => {
            types.push(x);
        });
        return types;
    },
    getType(key: string) {
        switch (parseInt(key)) {
            case 0:
                return identificationButtonLocationEnum.Top;
            case 1:
                return identificationButtonLocationEnum.Bottom;
            default:
                return identificationButtonLocationEnum.Top;
        }
    }
};
